export const articleList = [
  {
    id: 1,
    title: '某顶流男星深夜私会神秘女子 酒店共度八小时全程被拍',
    excerpt: '据知情人士透露，该男星与神秘女子在酒店密会长达八小时，期间保镖全程把守走廊，行踪极其隐蔽。女方身份已被扒出，竟是圈内某知名制片人。',
    content_html: '<p>据知情人士透露，该男星与神秘女子在酒店密会长达八小时，期间保镖全程把守走廊，行踪极其隐蔽。女方身份已被扒出，竟是圈内某知名制片人，在业内手握多个头部项目资源。</p><p>据酒店内部监控显示，两人于当晚十点前后分别进入酒店，刻意避开了大堂正门。该男星的私人保镖在楼层走廊来回巡视，严禁任何人靠近。直至次日清晨六时许，两人才先后离开。</p><p>消息爆出后，该男星工作室尚未作出任何回应。而其社交媒体评论区已被粉丝和吃瓜群众刷屏，相关话题阅读量三小时内突破两亿。据业内人士分析，此事可能对其正在洽谈的三个品牌代言产生重大影响。</p><p>截至发稿，事件仍在持续发酵中，我们将继续跟踪报道。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '吃瓜前线记者',
    publishedAt: '2026-07-06T22:30:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20hotel%20corridor%20scene%20with%20dramatic%20paparazzi%20style%20lighting%2C%20mysterious%20silhouette%20figures%2C%20luxury%20hotel%20interior%2C%20high%20contrast%20cinematic%20mood%2C%20editorial%20photography%2C%20warm%20tone%20highlights%20on%20dark%20background&width=800&height=500&seq=article-01-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20scandal%20hotel%20scene%20dramatic%20paparazzi%20photography%2C%20dark%20atmospheric%20lighting%2C%20mysterious%20figure%20in%20luxury%20hotel%2C%20intense%20mood%2C%20editorial%20news%20coverage%20aesthetic%2C%20warm%20and%20dark%20contrast&width=640&height=480&seq=article-01-card&orientation=landscape',
    tags: ['顶流', '酒店', '私会', '塌房'],
    views: 286000,
    comments: 15230,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [2, 3, 4, 7, 8],
  },
  {
    id: 2,
    title: '知名女星偷税漏税被罚八千万 工作室连夜注销账号跑路',
    excerpt: '税务部门最新通报显示，该女星通过阴阳合同、虚假发票等手段偷逃税款高达八千万。消息曝光后，其工作室所有社交账号全部注销。',
    content_html: '<p>税务部门最新通报显示，该女星通过阴阳合同、虚假发票等手段，在近三年间累计偷逃税款高达八千万元人民币。调查发现，其团队采用"拆分合同""虚假成本抵扣""境外壳公司走账"等多种手段规避税务监管。</p><p>通报发布后不到两小时，该女星工作室旗下所有社交平台账号（微博、抖音、小红书）全部注销，工作室办公地点也已人去楼空。其参演的三部待播影视作品面临下架风险，多家合作品牌紧急发布解约声明。</p><p>税务部门表示，此案已移交司法机关处理，该女星可能面临刑事追诉。业内人士分析，这是继某冰某爽事件后又一起引发行业震动的税务大案。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '税务稽查小王',
    publishedAt: '2026-07-06T18:15:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20tax%20document%20and%20legal%20papers%20on%20dark%20desk%20with%20dramatic%20lighting%2C%20investigative%20journalism%20style%2C%20high%20contrast%2C%20serious%20news%20atmosphere%2C%20warm%20desk%20lamp%20on%20dark%20documents&width=800&height=500&seq=article-02-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Tax%20investigation%20scene%20with%20legal%20documents%20and%20calculator%2C%20dramatic%20news%20lighting%2C%20Chinese%20office%20setting%2C%20serious%20atmosphere%2C%20editorial%20photography%2C%20warm%20golden%20accents%20on%20dark%20background&width=640&height=480&seq=article-02-card&orientation=landscape',
    tags: ['偷税', '女星', '八千万', '注销'],
    views: 452000,
    comments: 28900,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [1, 5, 6, 9, 10],
  },
  {
    id: 3,
    title: '千万粉丝网红直播翻车 假货被当场拆穿仓皇下播',
    excerpt: '该网红在直播间售卖所谓"海外代购正品"，被专业鉴定师当场拆穿。镜头前支支吾吾数分钟后突然断播，粉丝集体炸锅要求退款。',
    content_html: '<p>拥有超过千万粉丝的头部带货网红在昨晚直播中翻车，其所售的"海外专柜正品"被屏幕前的专业奢侈品鉴定师逐项指出破绽。鉴定师通过直播连麦指出，该手袋的五金件色泽、皮革纹理、内标字体均与正品存在明显差异。</p><p>该网红面对质疑支支吾吾，反复强调"渠道正规""有授权文件"，但始终无法出示实质性证明。在弹幕刷屏质疑声浪中，直播突然中断，此后一直未恢复。其粉丝群内已炸锅，大量消费者晒出购买记录要求退款。</p><p>平台方回应称已对涉事账号进行限制处理，并将配合市场监管部门调查。律师指出，若涉案金额巨大，该网红可能面临刑事责任。</p>',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    author: '打假专员阿明',
    publishedAt: '2026-07-06T14:20:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20luxury%20handbags%20and%20products%20on%20display%2C%20dramatic%20moment%20of%20confrontation%2C%20bright%20studio%20lights%20with%20dark%20shadows%2C%20intense%20atmosphere%2C%20editorial%20style&width=800&height=500&seq=article-03-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20handbag%20authentication%20scene%20with%20magnifying%20glass%2C%20dramatic%20lighting%2C%20counterfeit%20product%20examination%2C%20intense%20investigation%20mood%2C%20editorial%20photography&width=640&height=480&seq=article-03-card&orientation=landscape',
    tags: ['网红', '假货', '直播', '翻车'],
    views: 198000,
    comments: 12450,
    isHot: true,
    isNew: false,
    isExplosive: false,
    relatedArticles: [7, 8, 11, 12],
  },
  {
    id: 4,
    title: '某综艺导师私下辱骂学员录音曝光 节目组紧急发声明',
    excerpt: '一段长达十五分钟的录音在网络疯传，录音中某综艺节目导师对学员进行人格侮辱和言语霸凌。节目组凌晨发布声明称已暂停该导师一切录制工作。',
    content_html: '<p>一段长达十五分钟的录音于昨晚在网络社交平台疯传，录音中可以清晰地听到某热门综艺节目的常驻导师对学员进行长达数分钟的人格侮辱和言语霸凌，用词极其恶劣。</p><p>据知情人士透露，该录音发生在节目排练期间，起因是该学员在走台时出现了几个小失误。该导师不仅当众辱骂学员，还威胁要"让你在这行混不下去"。多名在场工作人员证实了此事。</p><p>节目组于凌晨三点紧急发布声明，宣布暂停该导师的一切录制工作，并表示将配合行业协会进行调查。多名曾与该导师合作过的艺人纷纷发文暗讽，暗示其恶劣行径由来已久。</p>',
    category: 'zongyi-baoliao',
    categoryName: '综艺爆料',
    author: '录音分析员老张',
    publishedAt: '2026-07-05T23:45:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20recording%20set%20with%20dramatic%20red%20and%20dark%20lighting%2C%20empty%20judge%20chair%20in%20spotlight%2C%20tense%20atmosphere%2C%20reality%20show%20stage%2C%20cinematic%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-04-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Reality%20TV%20show%20judge%20panel%20with%20dramatic%20spotlights%2C%20empty%20red%20chair%2C%20dark%20studio%20setting%2C%20tense%20atmosphere%2C%20editorial%20entertainment%20photography&width=640&height=480&seq=article-04-card&orientation=landscape',
    tags: ['综艺', '辱骂', '录音', '停职'],
    views: 321000,
    comments: 19800,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [9, 10, 13, 14],
  },
  {
    id: 5,
    title: '甜美偶像背后抽烟喝酒飙脏话 私密视频被内部人员外泄',
    excerpt: '一段偶像团体成员私下聚会的视频流出，画面中该偶像抽烟喝酒样样精通，满口脏话与台前甜美形象判若两人。经纪公司正在追查泄密源头。',
    content_html: '<p>一段偶像团体成员私下聚会的视频在网络上迅速扩散，画面中该偶像彻底颠覆了舞台上的甜美形象——熟练地吞云吐雾，对瓶吹啤酒，满口污言秽语，与台前的清纯人设形成巨大反差。</p><p>视频据信由该偶像的前助理拍摄并外泄。背景显示这是一个私人KTV包厢，在场的还有多名圈内人士。该偶像在视频中不仅喝酒抽烟，还对多名同行进行了不雅言论攻击。</p><p>经纪公司发布声明称，该视频为"断章取义的恶意剪辑"，并表示已报警处理、正在追查泄密源头。然而多位技术专家分析后认为，视频无剪辑痕迹，属于原始素材。</p>',
    category: 'fancha-shipin',
    categoryName: '反差视频',
    author: '秘密线人阿杰',
    publishedAt: '2026-07-05T20:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=KTV%20private%20room%20with%20neon%20pink%20and%20purple%20mood%20lighting%2C%20dramatic%20contrast%20between%20cute%20idol%20poster%20and%20dark%20atmosphere%2C%20celebrity%20duality%20theme%2C%20editorial%20photography&width=800&height=500&seq=article-05-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Split%20image%20concept%20of%20sweet%20idol%20versus%20dark%20side%2C%20contrasting%20personalities%2C%20pink%20and%20dark%20lighting%2C%20dramatic%20duality%2C%20editorial%20entertainment%20photography&width=640&height=480&seq=article-05-card&orientation=landscape',
    tags: ['偶像', '反差', '视频外泄', '人设崩塌'],
    views: 534000,
    comments: 35600,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [1, 2, 6, 11],
  },
  {
    id: 6,
    title: '知名导演潜规则女演员聊天记录曝光 多名女星勇敢站出来',
    excerpt: '数十页微信聊天截图揭露某大牌导演利用选角之便对女演员进行骚扰。截至目前已有七位女演员实名发声，其中三位表示已委托律师取证。',
    content_html: '<p>数十页微信聊天截图于今晨在网络上大规模曝光，揭露了某知名电影导演利用选角和试镜之便，对多名年轻女演员进行言语骚扰和不当邀约的行为。聊天记录中，该导演以"角色机会""单独指导"为由，不断试探和施压。</p><p>截至目前，已有七位女演员实名站出，公开证实自己曾遭该导演骚扰。其中三位表示已委托律师进行取证，不排除提起诉讼的可能。此外，还有超过二十位圈内女性工作者在社交媒体上使用#我也是#话题分享了自己的类似经历。</p><p>该导演尚未对此事作出回应，但其正在筹备的新片投资方已宣布暂停合作。中国电影导演协会表示将对此事展开调查。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '娱乐圈调查员',
    publishedAt: '2026-07-05T16:30:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20director%20chair%20in%20spotlight%2C%20dramatic%20shadows%2C%20empty%20audition%20room%2C%20tense%20atmosphere%2C%20power%20imbalance%20theme%2C%20cinematic%20editorial%20photography%20with%20warm%20and%20dark%20contrast&width=800&height=500&seq=article-06-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20dark%20movie%20set%20with%20dramatic%20lighting%2C%20empty%20audition%20space%2C%20power%20dynamics%20theme%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=640&height=480&seq=article-06-card&orientation=landscape',
    tags: ['导演', '潜规则', '聊天记录', '实名举报'],
    views: 612000,
    comments: 42300,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [1, 2, 5, 14],
  },
  {
    id: 7,
    title: '美食博主厨房脏乱差实拍流出 号称米其林级别真相令人作呕',
    excerpt: '一位自称在米其林餐厅工作过的美食博主，其真实厨房环境被隔壁邻居偷拍曝光。蟑螂满地、食材过期、卫生堪忧，与其视频中精致画面天差地别。',
    content_html: '<p>一位自称曾在米其林三星餐厅工作、拥有三百万粉丝的美食博主，其真实厨房环境被邻居偷拍曝光。视频显示，厨房地面蟑螂乱窜，操作台油渍斑斑，冰箱内食材大量过期变质，甚至发现了发霉的调料和长虫的面粉。</p><p>这与该博主在视频中展示的精美开放式厨房、一尘不染的烹饪环境形成了巨大反差。其售卖的"私房酱料"正是在这样的环境中生产的。食品卫生监管部门已介入调查，该博主的所有商品链接已被电商平台下架。</p>',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    author: '食品安全观察员',
    publishedAt: '2026-07-05T11:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20kitchen%20with%20pests%20and%20mess%2C%20contrast%20with%20beautiful%20food%20photography%20in%20foreground%2C%20dramatic%20reveal%2C%20dark%20kitchen%20lighting%2C%20editorial%20investigative%20photography&width=800&height=500&seq=article-07-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Filthy%20restaurant%20kitchen%20with%20contrast%20to%20elegant%20food%20presentation%2C%20dramatic%20before%20and%20after%2C%20dark%20revealing%20photography%2C%20editorial%20style&width=640&height=480&seq=article-07-card&orientation=landscape',
    tags: ['美食博主', '卫生', '翻车', '虚假宣传'],
    views: 187000,
    comments: 9800,
    isHot: false,
    isNew: false,
    isExplosive: false,
    relatedArticles: [3, 8, 11, 12],
  },
  {
    id: 8,
    title: '健身博主P图前后对比惊呆网友 六块腹肌竟是软件生成',
    excerpt: '技术大神扒出某百万粉丝健身博主所有照片均为重度PS产物，原图中该博主身材平平无奇。其售卖的健身课程累计销售额超五百万，学员集体要求退款。',
    content_html: '<p>一位数字图像分析专业人士在社交平台发布了一篇深度技术贴，逐帧分析了某百万粉丝健身博主的全部发布内容，得出结论：该博主的"完美身材"全部通过图像处理软件生成，从腹肌到手臂线条，无一例外都是PS产物。</p><p>对比分析显示，该博主原始体型与普通中年男性无异，略有肚腩，毫无训练痕迹。但其售卖的线上健身课程累计销售额已超过五百万元，声称"只需三个月就能拥有同款身材"。</p><p>爆料发酵后，超过三千名付费学员组建维权群，集体要求退款。平台已对该账号进行限制，课程链接被暂时下架。消费者协会表示已收到大量投诉，正在评估是否启动公益诉讼。</p>',
    category: 'fancha-shipin',
    categoryName: '反差视频',
    author: 'PS鉴定师小王',
    publishedAt: '2026-07-04T21:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Before%20and%20after%20photo%20editing%20concept%20with%20fitness%20transformation%20fake%20reveal%2C%20dramatic%20contrast%2C%20computer%20screen%20with%20photoshop%20interface%2C%20dark%20mood%2C%20editorial%20photography&width=800&height=500&seq=article-08-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Photo%20editing%20software%20screen%20showing%20body%20transformation%2C%20fake%20fitness%20reveal%2C%20dramatic%20before%20and%20after%2C%20dark%20digital%20atmosphere%2C%20editorial%20style&width=640&height=480&seq=article-08-card&orientation=landscape',
    tags: ['健身博主', 'P图', '欺诈', '退款'],
    views: 276000,
    comments: 15600,
    isHot: false,
    isNew: false,
    isExplosive: false,
    relatedArticles: [3, 5, 7, 11],
  },
  {
    id: 9,
    title: '某选秀节目暗箱操作内幕 投票数据全部造假',
    excerpt: '前节目组工作人员匿名爆料，某热门选秀节目的观众投票系统根本不存在，所有排名均由导演组内定。相关聊天记录和内部文件已被提交至监管部门。',
    content_html: '<p>一位自称在某热门选秀节目工作了两年的前员工，以匿名方式向媒体爆料：该节目持续三年的观众投票环节完全是虚假的，所谓"实时投票数据"全部由导演组在后台手动输入，选手排名早在录制前就已确定。</p><p>该前员工提供了大量内部聊天记录和会议纪要作为证据，显示导演组每周会召开"排位会议"，根据选手的商业价值和话题度来分配排名。他还透露，有选手经纪公司明码标价购买"保底名次"，价格从五十万到三百万不等。</p><p>相关材料已被提交至广播电视主管部门。若查证属实，这将是中国综艺史上最大的造假丑闻之一。</p>',
    category: 'zongyi-baoliao',
    categoryName: '综艺爆料',
    author: '前节目组员工',
    publishedAt: '2026-07-04T17:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20voting%20screen%20showing%20fake%20numbers%2C%20behind%20the%20scenes%20corruption%20theme%2C%20dramatic%20red%20and%20dark%20lighting%2C%20rigged%20competition%2C%20editorial%20photography&width=800&height=500&seq=article-09-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20voting%20panel%20with%20manipulated%20numbers%2C%20dark%20behind%20scenes%2C%20rigged%20system%20reveal%2C%20dramatic%20studio%20lighting%2C%20editorial%20style&width=640&height=480&seq=article-09-card&orientation=landscape',
    tags: ['选秀', '暗箱操作', '造假', '举报'],
    views: 389000,
    comments: 23400,
    isHot: true,
    isNew: false,
    isExplosive: false,
    relatedArticles: [4, 10, 13, 14],
  },
  {
    id: 10,
    title: '喜剧演员私下重度抑郁 台上欢笑台下崩溃令人心疼',
    excerpt: '多位圈内好友透露，某知名喜剧演员长期受抑郁症困扰，多次在后台崩溃大哭。其在社交媒体上发布的"一切都好"的动态背后，是无数个失眠的夜晚。',
    content_html: '<p>该喜剧演员的多位圈内好友近日在接受采访时透露，这位总是在台上带给观众欢笑的喜剧人，幕后正与重度抑郁症搏斗多年。多位好友证实，他曾在演出后在后台崩溃大哭，需要工作人员搀扶才能离开。</p><p>然而在同一时期，他的社交媒体上发布的全部是"一切都好""感恩生活"的正能量内容。这种台上欢笑台下崩溃的巨大反差，引发了公众对演艺人员心理健康问题的广泛关注和讨论。</p><p>心理健康专家呼吁，不应将喜剧演员标签化为"必须快乐的人"，他们同样需要被理解和关怀。该演员所属经纪公司表示，已为其安排了专业心理辅导。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '心理健康关注者',
    publishedAt: '2026-07-04T09:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20comedy%20stage%20with%20single%20spotlight%2C%20sad%20clown%20theme%2C%20contrast%20between%20bright%20stage%20and%20dark%20backstage%2C%20emotional%20duality%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=article-10-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20stage%20with%20contrasting%20dark%20backstage%2C%20sad%20performer%20duality%2C%20empty%20theater%20spotlight%2C%20emotional%20contrast%2C%20editorial%20photography&width=640&height=480&seq=article-10-card&orientation=landscape',
    tags: ['喜剧演员', '抑郁', '心理健康', '反差'],
    views: 234000,
    comments: 18900,
    isHot: false,
    isNew: false,
    isExplosive: false,
    relatedArticles: [1, 2, 6, 5],
  },
  {
    id: 11,
    title: '旅游博主景点照全靠抠图 从未出过国却年入百万',
    excerpt: '技术分析显示某旅游博主的"环球旅行"照片全部通过绿幕抠图和AI合成，该博主实际居住在国内三线城市从未出过境。其代购的"海外商品"来源成谜。',
    content_html: '<p>一名数字取证爱好者对某拥有五百万粉丝的旅游博主进行了长达三个月的追踪分析，得出了惊人结论：该博主所有"环球旅行"照片均为绿幕抠图与AI合成产物。通过分析光影一致性、透视关系和像素特征，该博主从未离开过其所在的三线城市。</p><p>更令人震惊的是，该博主通过销售所谓的"海外代购商品"和旅行攻略课程，年收入已超过百万元。而其售卖的"巴黎香水""日本药妆"等商品来源至今成谜。市场监管部门表示已接到举报，正在展开调查。</p>',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    author: '技术流吃瓜群众',
    publishedAt: '2026-07-03T19:30:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Green%20screen%20studio%20setup%20with%20travel%20posters%20and%20fake%20scenery%2C%20exposed%20behind%20scenes%2C%20dramatic%20reveal%2C%20dark%20studio%20with%20bright%20fake%20background%2C%20editorial%20photography&width=800&height=500&seq=article-11-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Green%20screen%20studio%20with%20fake%20travel%20background%20revealed%2C%20exposed%20deception%2C%20dramatic%20contrast%2C%20editorial%20investigation%20style%20photography&width=640&height=480&seq=article-11-card&orientation=landscape',
    tags: ['旅游博主', '抠图', '造假', '代购'],
    views: 345000,
    comments: 21200,
    isHot: true,
    isNew: false,
    isExplosive: false,
    relatedArticles: [3, 7, 8, 12],
  },
  {
    id: 12,
    title: '宠物博主虐猫视频意外入镜 百万粉丝账号遭全网封杀',
    excerpt: '该宠物博主最新视频中镜头一角意外拍到其用力踢踹猫咪的画面，虽然仅出现两秒但被眼尖网友截图放大。平台已永久封禁其账号，动保组织已报警处理。',
    content_html: '<p>拥有三百万粉丝的宠物博主在最新发布的一则"猫咪卖萌"视频中，画面边缘意外拍到了极其残忍的一幕：该博主用力踢踹一只试图靠近镜头的猫咪。这个画面虽然仅持续两秒且处于画面边缘，但被眼尖的网友逐帧截图并放大。</p><p>截图在网络上迅速传播后，动保组织和大量网友涌入其账号评论区谴责。平台在数小时内作出反应，宣布永久封禁该账号。当地动物保护协会表示已向公安机关报案，警方已介入调查。</p>',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    author: '动保志愿者小陈',
    publishedAt: '2026-07-03T12:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20cat%20in%20foreground%20with%20dark%20shadow%20figure%20in%20background%2C%20hidden%20cruelty%20reveal%2C%20dramatic%20contrast%2C%20warm%20pet%20scene%20with%20dark%20undertone%2C%20editorial%20photography&width=800&height=500&seq=article-12-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Cat%20with%20dark%20shadow%20in%20background%2C%20hidden%20animal%20cruelty%20theme%2C%20dramatic%20contrast%20between%20cute%20and%20dark%2C%20editorial%20style%20photography&width=640&height=480&seq=article-12-card&orientation=landscape',
    tags: ['宠物博主', '虐猫', '封杀', '报警'],
    views: 498000,
    comments: 34500,
    isHot: true,
    isNew: false,
    isExplosive: false,
    relatedArticles: [3, 7, 8, 11],
  },
  {
    id: 13,
    title: '某情感综艺嘉宾全是剧本演员 真情实感全是演的',
    excerpt: '内部人士曝光某热门情感调解类综艺节目的嘉宾全部是签约演员，所谓的"真实故事"均由编剧团队创作。节目组按集支付演员费用，收视率越高薪酬越丰厚。',
    content_html: '<p>一位自称在情感综艺行业工作多年的内部人士向媒体爆料：某热播多年、收视率居高不下的情感调解类综艺节目，其舞台上的所有"当事人"均为节目组签约的专业演员，没有一个案例是真实的。</p><p>据该内部人士透露，节目组配备了专职编剧团队，每周根据社会热点和观众情绪来"量身定做"故事线。演员按集领取片酬，收视率越高，薪酬越丰厚。那些在台上声泪俱下的"当事人"，下了台就和节目组一起有说有笑地吃夜宵。</p><p>这一爆料引发了观众极大愤怒，许多人表示"被欺骗了这么多年"。但也有业内人士表示，这类节目"本质是娱乐综艺而非新闻纪实"，呼吁观众理性看待。</p>',
    category: 'zongyi-baoliao',
    categoryName: '综艺爆料',
    author: '电视圈内行人',
    publishedAt: '2026-07-02T20:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20with%20emotional%20talk%20show%20set%2C%20dramatic%20red%20curtains%2C%20empty%20guest%20chairs%2C%20fake%20reality%20theme%2C%20behind%20the%20scenes%20exposed%2C%20editorial%20photography&width=800&height=500&seq=article-13-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Talk%20show%20TV%20set%20with%20dramatic%20red%20lighting%2C%20empty%20guest%20chairs%2C%20fake%20reality%20show%20theme%2C%20behind%20scenes%20exposed%2C%20editorial%20style&width=640&height=480&seq=article-13-card&orientation=landscape',
    tags: ['情感综艺', '剧本', '演员', '造假'],
    views: 267000,
    comments: 14300,
    isHot: false,
    isNew: false,
    isExplosive: false,
    relatedArticles: [4, 9, 10, 14],
  },
  {
    id: 14,
    title: '某男团队内霸凌多年 最小成员被逼到退团治疗',
    excerpt: '匿名前工作人员揭露某当红男团内部存在严重霸凌现象，最小成员长期被孤立、嘲讽甚至肢体推搡。该成员已因重度焦虑和抑郁退团接受心理治疗。',
    content_html: '<p>一位自称在某当红男团工作了三年的前工作人员匿名向媒体揭露：该团体内部存在严重的霸凌文化，年龄最小的成员长期受到其他成员的孤立、言语嘲讽和肢体推搡。在巡演期间，其他成员会在化妆间故意孤立他，甚至将他的私人物品藏起来。</p><p>该成员最终因重度焦虑和抑郁症状申请退团，目前正在接受专业心理治疗。其家人已委托律师，准备对经纪公司和霸凌成员提起诉讼。经纪公司回应称"成员之间只是正常的磨合和玩笑"，但多位前员工的说法与此相矛盾。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '前工作人员匿名',
    publishedAt: '2026-07-02T14:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%2C%20lonely%20figure%20silhouette%2C%20boy%20band%20bullying%20theme%2C%20dark%20atmosphere%2C%20contrast%20with%20bright%20stage%2C%20editorial%20photography&width=800&height=500&seq=article-14-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Empty%20dance%20studio%20with%20lonely%20silhouette%2C%20boy%20band%20dark%20side%2C%20mirror%20reflection%20showing%20isolation%2C%20dramatic%20lighting%2C%20editorial%20style&width=640&height=480&seq=article-14-card&orientation=landscape',
    tags: ['男团', '霸凌', '退团', '心理健康'],
    views: 423000,
    comments: 28900,
    isHot: true,
    isNew: false,
    isExplosive: false,
    relatedArticles: [1, 6, 9, 10],
  },
  {
    id: 15,
    title: '带货主播卖假黄金被质检部门抓现行 涉案金额超两千万',
    excerpt: '该主播声称的"999足金"饰品经检测实为镀金合金，成本不到售价的百分之一。质检部门和公安已联合执法，直播现场被查封，主播当场被带走调查。',
    content_html: '<p>一场惊心动魄的执法行动在昨晚的带货直播中实时上演。该知名带货主播正在激情推销"999足金生肖吊坠"时，质检部门和公安执法人员突然闯入直播现场。经现场检测，其所售"足金"实为镀金合金，黄金含量几乎为零。</p><p>执法人员当场查封了直播间和仓库，查获大量假金饰和伪造的检测证书。该主播被当场戴上手铐带走。经初步统计，其通过直播销售假黄金饰品的累计涉案金额已超过两千万元，受害者遍布全国各地。</p>',
    category: 'wanghong-heiliao',
    categoryName: '网红黑料',
    author: '质检特派员',
    publishedAt: '2026-07-01T10:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Police%20raid%20on%20live%20streaming%20studio%2C%20fake%20gold%20jewelry%20confiscated%2C%20dramatic%20law%20enforcement%20action%2C%20bright%20studio%20lights%20with%20police%20uniforms%2C%20editorial%20news%20photography&width=800&height=500&seq=article-15-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Fake%20gold%20jewelry%20and%20police%20raid%20on%20streaming%20studio%2C%20counterfeit%20goods%20confiscated%2C%20dramatic%20enforcement%20scene%2C%20editorial%20news%20style&width=640&height=480&seq=article-15-card&orientation=landscape',
    tags: ['带货', '假黄金', '质检', '涉案两千万'],
    views: 567000,
    comments: 41200,
    isHot: true,
    isNew: false,
    isExplosive: true,
    relatedArticles: [3, 7, 11, 12],
  },
  {
    id: 16,
    title: '说唱歌手歌词抄袭被原唱起诉 粉丝反而网暴原作者',
    excerpt: '某当红说唱歌手多首热门歌曲被证实抄袭国外小众音乐人作品，旋律和歌词高度雷同。原作者发布维权声明后竟遭到该歌手粉丝大规模网暴。',
    content_html: '<p>一位国外小众音乐人在社交平台上发布对比视频，指控某中国当红说唱歌手的多首热门歌曲直接抄袭了他的作品。对比显示，不仅旋律高度雷同，部分中文歌词也是对其英文歌词的直译或意译。</p><p>原作者表示已委托中国律师提起诉讼，要求下架侵权歌曲并索赔。然而维权声明发布后，该说唱歌手的粉丝不仅不支持原创，反而对原作者发起了大规模网络暴力，在其社交账号下刷屏辱骂和威胁。</p><p>这一事件引发了关于音乐版权保护和粉丝文化的广泛讨论。多位音乐人联合发声，呼吁尊重原创、理性追星。该说唱歌手本人尚未回应抄袭指控。</p>',
    category: 'mingxing-tafang',
    categoryName: '明星塌房',
    author: '音乐版权律师',
    publishedAt: '2026-06-30T15:00:00Z',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20sheet%20music%20comparison%2C%20plagiarism%20theme%2C%20dramatic%20split%20screen%20concept%2C%20original%20versus%20copy%2C%20dark%20studio%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=article-16-main&orientation=landscape',
    cardImageUrl: 'https://readdy.ai/api/search-image?query=Music%20plagiarism%20comparison%20concept%20with%20sheet%20music%2C%20original%20versus%20copy%2C%20dark%20studio%20with%20dramatic%20lighting%2C%20copyright%20theme%2C%20editorial%20style&width=640&height=480&seq=article-16-card&orientation=landscape',
    tags: ['说唱', '抄袭', '起诉', '网暴'],
    views: 312000,
    comments: 19800,
    isHot: false,
    isNew: false,
    isExplosive: false,
    relatedArticles: [1, 2, 6, 14],
  },
];

export interface ArticleItem {
  id: number;
  title: string;
  excerpt: string;
  content_html: string;
  category: string;
  categoryName: string;
  author: string;
  publishedAt: string;
  imageUrl: string;
  cardImageUrl: string;
  tags: string[];
  views: number;
  comments: number;
  isHot: boolean;
  isNew: boolean;
  isExplosive: boolean;
  relatedArticles: number[];
}